import {Component, OnInit, ElementRef} from '@angular/core';
import {AuthService} from '../../auth/auth.service';
import {Router} from '@angular/router';
import {GlobalService} from "../../global/global.service";
import {environment} from "../../../environments/environment";

@Component({
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
  selector: 'nuc-site-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

   isOpen = false;
  constructor(private authService: AuthService,
              private router: Router,
              private _eref: ElementRef,
              private global: GlobalService) { }

  ngOnInit() {
  }

  redirectToLogin() {
    this.authService.openLoginWindow();
  }
  onDocumentClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  navigateToBlog() {
    window.open('https://medium.com/cantiz', '_blank');
  }

  navigateToDeveloperDoc() {
    window.open(environment.devDocUrl, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/site/header/header.component.ts